var $j = jQuery.noConflict();
$j(document).ready(function () {  
  
    $j('.sidebar').find('a').on('click', function(e){
        if ($j(window).width() < 960) {
        $j('.sidebar-toggle').trigger('click');
    }  
    });
      
});
        